<template>
    <div class="horizontal grow gallery-container" style="min-width: 700px; width: 50vw; height: 70vh">
        <div id="info-container">
            <div>
                <p class="section-title">{{ $t('USER_INFORMATION') }}</p>
                <div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Role') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <select v-model="user.role" >
                                    <option v-for="(role, index) in ['User', 'PC', 'Service', 'Admin', 'Server']" :key="index">{{ role }}</option>
                                </select>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ user.role != 'Server' ? $t('FirstName') : $t('Name') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.firstName" type="text" :placeholder="user.role != 'Server' ? $t('FirstName') : $t('Name')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal" v-if="user.role != 'Server'">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Surname') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.lastName" type="text" :placeholder="$t('LastName')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal" v-if="user.role == 'Server'">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Address') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="serverAddress" type="text" :placeholder="$t('Address')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Email') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.email" type="email" :placeholder="$t('Email')" :disabled="userObj != null ? true : false">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal" v-if="userObj == null">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('Password') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.password" type="password" :placeholder="$t('Password')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal" v-if="user.role != 'Server'">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('PhoneNumber') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <input v-model="user.phoneNumber" type="text" :placeholder="$t('PhoneNumber')">
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal" v-if="user.role != 'Server'">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('AccessToSystems') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <div v-for="(sys, index) in access" :key="index">{{ sys.systemName }}</div>
                            </td>
                        </tr>
                    </div>
                    <div class="info-field horizontal" v-if="user.role != 'Server'">
                        <tr class="info-field-row">
                            <td style="width:200px;"><p class="info-field-title">{{ $t('AccessByGroups') }}</p></td>
                            <td style="width:200px;" class="info-field-value">
                                <div v-for="(sys, index) in sysGroups" :key="index">{{ sys.name }}</div>
                            </td>
                        </tr>
                    </div>
                    <div>
                        <div class="error" v-if="error != ''">{{ error }}</div>
                    </div>
                </div>
            </div>
            <div style="align-self: center;">
                <Button :title="$t('Save')" buttonClass='save-button semi-bold' style="width: 300px; align-self: center;" @onClick="save"></Button>
            </div>
        </div>
        <div id="systems-container" style="display: block;" v-if="user.role != 'Server'">
            <h4 style="padding-top: 10px;">{{ $t('Systems') }}</h4>
            <div style="height: 44%; width: 90%; margin: auto; padding: 0 0 10px 0;">
                <ejs-grid ref="modal_grid" height='100%' width='100%' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="systems" :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :showBusyIndicator="true" :rowSelected="selectionChanged" :rowDeselected="selectionChanged">
                    <e-columns>
                        <e-column type='checkbox' width='50' headerText='Discontinued' textAlign='Left'></e-column>
                        <e-column field='systemName' :headerText="$t('SystemName').toUpperCase()" textAlign='Left'></e-column>
                        <e-column field='country' :headerText="$t('Country').toUpperCase()" textAlign='Left' :filter="filterCheckbox"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <h4 >{{ $t('Groups') }}</h4>
            <div style="height: 44%; width: 90%; margin: auto; padding: 0 0 10px 0;">
                <ejs-grid ref="groups_grid" height='100%' width='100%' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="groups" :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :showBusyIndicator="true" :rowSelected="groupsSelectionChanged" :rowDeselected="groupsSelectionChanged">
                    <e-columns>
                        <e-column type='checkbox' width='50' headerText='Discontinued' textAlign='Left'></e-column>
                        <e-column field='name' :headerText="$t('NAME')" textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>

<script>
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, GridPlugin } from '@syncfusion/ej2-vue-grids';
import { registerUser, updateUserAccountData, updateUserSystems, getUserSystemById, 
    updateUserRole, getUserById, getSystemsWithCountries, assignUserToGroups, addServerConfiguration } from '@/api/api'
import Button from '../Button.vue';
import Select from '../Select'
import { assignServerManager, getExistingGroups } from '../../api/api';

export default {
    props: {
        userObj: {
            required: false,
            type: Object
        }
    },
    components: {
        Button,
        Select
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn ]
    },
    data() {
        return {
            user: {
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                role: 'User',
                accessToSystems: [],
                password: '',
                systemGroups: []
            },
            serverAddress: '',
            systems: [],
            groups: [],
            error: "",

            wrapSettings: { wrapMode: 'Content' } ,
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            filterCheckbox: {
                type: "CheckBox",
            },
        }
    },
    computed: {
        access(){
            return this.user.accessToSystems;
        },
        sysGroups() {
            return this.user.systemGroups
        },
    },
    methods: {
        async getUser() {
            this.systems = await getSystemsWithCountries();
            this.groups = await getExistingGroups();

            if(this.userObj == null)
                return;

            var usr = await getUserById(this.userObj.id)
            this.user.id = usr.id;
            this.user.firstName = usr.firstName;
            this.user.lastName = usr.lastName;
            this.user.email = usr.email;
            this.user.phoneNumber = usr.phone;
            this.user.role = usr.roles.length != 0 ? usr.roles[0] : '';
            this.user.accessToSystems = []
            var userSystems = await getUserSystemById(this.userObj.id);
            var systemsIndex = [];

            if(this.user.role == 'Server') {
                this.serverAddress = usr.cloudAddress;
                return;
            }

            // console.log({user: this.user, usr: usr, systems: userSystems})

            for(let i = 0; i < userSystems.systems.length; i++) {
              var x = this.systems.filter(m => m.id == userSystems.systems[i].id);

              if(x != null && x.length > 0) {
                this.user.accessToSystems.push(x[0]);

                for(let j = 0; j < this.systems.length; j++){
                    if(this.systems[j].id == x[0].id){
                        systemsIndex.push(j);
                        break;
                    }
                }

              }
            }

            this.$refs.modal_grid.selectRows(systemsIndex);

            var groupsIndexes = []
            var groupnames = this.groups.map(x => x.name);
            for(let i = 0; i < userSystems.systemGroups.length; i++){
                var g = userSystems.systemGroups[i]
                var idx = groupnames.indexOf(g.name)
                groupsIndexes.push(idx)
            }

            // console.log({systemGroups: userSystems.systemGroups, groupsIndexes, groupnames})

            this.$refs.groups_grid.selectRows(groupsIndexes)
        },
        groupsSelectionChanged() {
            this.user.systemGroups = []
            this.user.systemGroups = this.$refs.groups_grid.getSelectedRecords();
            // console.log(this.user.systemGroups)
        },
        selectionChanged() {
            this.user.accessToSystems = [];
            this.user.accessToSystems = this.$refs.modal_grid.getSelectedRecords();
            // console.log(this.user.accessToSystems)
        },
        dataBound: function() {
            this.$refs.modal_grid.autoFitColumns();
        },
        async save() {
            if (this.userObj != null){
                this.user.surname = this.user.lastName;
                try {
                    await updateUserAccountData(this.user)
                } catch (error) {
                    this.processError(error)
                }

                if (this.user.role != 'Server') {
                    let groups = this.user.systemGroups.map(x => x.name)
                    try {
                        await assignUserToGroups(this.user.id, groups)
                    } catch(error) {
                        this.processError(error)
                    }

                    try{
                        await updateUserSystems({id: this.user.id, systems: this.user.accessToSystems})
                    } catch (error) {
                        this.processError(error)
                    }
                } else {
                    // todo add edit for server config
                }

                try {
                    await updateUserRole(this.user.id, this.user.role)
                } catch (error) {
                    this.processError(error)
                }

                this.$emit("save");
            } else {
                this.error = ''
                try {
                    var newUser = await registerUser(this.user)
                    if(newUser.data != undefined) {
                        if (this.user.role != 'Server') {
                            await updateUserSystems({id: newUser.data.userId, systems: this.user.accessToSystems})
                            await assignUserToGroups(newUser.data.userId, this.user.systemGroups.map(x => x.name))
                        } else {
                            var serverData = await addServerConfiguration({
                                name: `${this.user.firstName} ${this.user.lastName}`,
                                address: this.serverAddress
                            })

                            console.dir(newUser)

                            await assignServerManager(serverData.id, newUser.data.userId);
                        }

                        if (this.error == ''){
                            this.$emit("save");
                        }
                    }
                } catch(error) {
                    console.dir(error)
                    this.processError(error)
                }
            }
        },
        processError(error){
            if(error.response.data[0] != undefined){
                this.error = error.response.data[0].description
            } else {
                // console.log({err: error.response})
                this.error = ""
                if(error.response.data.errors.Password != undefined) {
                    this.error = error.response.data.errors.Password[0]
                } else if (error.response.data.errors.Email != undefined) {
                    this.error = error.response.data.errors.Email[0]
                }
            }

        }
    },
    mounted: async function() {
        this.getUser();
    }
}
</script>

<style scoped>
h4 {
    text-align: center;
    font-size: 18px;
}

.error {
    text-align: left !important;
    color: #FD8282;
    font-size: 11px;
    font-weight: bold;
    font-family: 'Open Sans', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

#info-container {
    width: 50%;
    padding: 20px;

    background: #FFFFFF;
    border: 1px solid #EFEFEF;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;

    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

#systems-container {
    width: 50%;
    align-items: center;
    justify-content: center;
    /* margin: auto; */
}

.gallery-container {
    background: #F9F9F9;
    box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);
    border-radius: 5px;
}

.info-field {
    border-bottom: 1px solid #E9E9E9;
    margin-bottom: 12px;
    margin-top: 12px;
}

.info-field-title {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
    margin: 0;
}

.info-field-row {
    width: 100%;
    margin: 0;
    padding-bottom: 5px;
}

.info-field-value {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;

    color: #272727;
}

.section-title {
    font-weight: bold;
}

input[type=text], input[type="email"], input[type="password"] {
    border: none;
    width: 100%;
}

input[type=text]:focus, input[type="email"]:focus, input[type="password"]:focus {
    border-bottom: 1px solid #0095b2;
    outline: none;
}

select {
    border: none;
    width: 100%;
}

select:focus {
    outline: none;
    border-bottom: 1px solid #0095b2;
}

option {
    padding: 4px;
}

option:checked {
    background: #347C93;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/UserModal.vue